import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadablePasswordResetRequest = Loadable({
  loader: function loader() {
    return import('../PasswordResetRequest.jsx');
  },
  loading: ComponentLoading
});
export default LoadablePasswordResetRequest;